import { styled, SxProps } from '@mui/material/styles';

export const appBarButtonSx: SxProps = {
  color: 'text.secondary',
  fontWeight: 'normal',
  '&:visited, &:focus, &:active': {
    color: 'text.secondary',
    backgroundColor: 'transparent',
  },
  alignItems: 'center',
};

export const appBarButtonSxMobile: SxProps = { ...appBarButtonSx, '& .MuiButton-startIcon': { margin: 0 } };

export const rowFlex: SxProps = { display: 'flex', flexDirection: 'row' };

export const columnFlex: SxProps = { display: 'flex', flexDirection: 'column' };

export const centerAlignment: SxProps = {
  alignItems: 'center',
  justifyContent: 'center',
};

export const centerAlignmentWithSpaceBetween: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const reportGridContainer = {
  ...columnFlex,
  gap: 3,
};

export const rowFlexSpaceBetween: SxProps = {
  ...rowFlex,
  justifyContent: 'space-between',
};

export const flexCenter: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export function getReportPageKPICardsOuterBoxSx(isMobile: boolean): SxProps {
  return {
    ...flexCenter,
    flexDirection: isMobile ? 'column' : 'row',
    gap: isMobile ? '20px' : '10px',
  };
}

export const alignItemsStart: SxProps = {
  alignItems: 'start',
};

export const actionButton = {
  height: '44px',
};

export const paddingTop3: SxProps = {
  paddingTop: '24px',
};

export const paddingY3: SxProps = {
  paddingY: '24px',
};

export const paddingX3: SxProps = {
  paddingX: '24px',
};

export const textFieldNoUnderlineSx: SxProps = {
  '& .MuiInput-underline:before': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:after': {
    borderBottom: 'none',
  },
  '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
    borderBottom: 'none',
  },
};

export const fullWidthInlineBlock: SxProps = {
  display: 'inline-block',
  width: '100%',
};

export const pagePadding: SxProps = {
  p: 4,
};

export const overflowEllipsis: SxProps = {
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  display: 'inline-block',
  textOverflow: 'ellipsis',
};

export const StyledWarningList = styled('ul')(({ theme }) => ({
  color: '#5d3700be',
  margin: 0,
  paddingLeft: theme.spacing(2),
  listStyleType: 'disc',
}));
